export const supportedFileTypesForPreview = ['pdf'];

//
export const LOCAL_STORAGE_KEY = 'mage-cache-storage';
export const MAX_PROJECTS = 5;
export const API = {
  projectPhases: '/projects/api/phases',
  projectSetList: '/sdg_project/project/projectssetlist',
};
